import { AmplienceVideo } from '@/types/amplience';

/**
 * Amplience transcoding profile names, paired by container. WebM is listed first at every
 * call site because browsers pick the first playable source in document order.
 */
export const VIDEO_FORMATS = {
  square: { webm: 'fullsquare11_webm', mp4: 'fullsquare11_mp4' },
  wide: { webm: 'default_webm', mp4: 'default_mp4' },
  heroDesktop: { webm: 'hero_desktop_webm', mp4: 'hero_desktop_mp4' },
  heroMobile: { webm: 'hero_mobile_webm', mp4: 'hero_mobile_mp4' },
} as const;

export const getVideoUrl = (video: AmplienceVideo | undefined, format: string) => {
  return `https://${video?.defaultHost}/v/${video?.endpoint}/${video?.name}/${format}/`;
};
